import { FC, useEffect } from 'react';
import { PageTitle, Page, SeoBlock } from '@edikk-edikk/country-layout-black';
import { ContentLoader } from '@edikk-edikk/country-common';
import { useProcessApiError } from '@edikk-edikk/hooks';
import { useAdvertListData } from '@edikk-edikk/country-frontend';
import { CatalogByDate, CatalogByService } from '#advertList/components';
import { useInit } from '#advertList/hooks';
import { Filter } from '#advertList/components/filter/Filter';
import { AdvertListContext } from '#advertList/contexts/AdvertListContext';
import { AdvertListContextType } from '#advertList/contexts/AdvertListContextType';
import { AdvertListMetaData } from '#advertList/components/AdvertListMetaData';
import { StoryList } from '#advert/modules/story/list';

type PropsType = {
  categoryId?: number;
  nationalityId?: number;
  cityId?: number;
  areaId?: number;
};

const List: FC<PropsType> = ({
  categoryId = undefined,
  nationalityId = undefined,
  cityId = undefined,
  areaId = undefined,
}) => {
  const init = useInit(categoryId, nationalityId, cityId, areaId);
  const {
    data,
    advertDataListByDate,
    advertDataListByService,
    isFetching,
    isLoading,
    isError,
    error,
  } = init();
  const advertListData = useAdvertListData();
  useProcessApiError(error);

  useEffect(() => {
    advertListData.setCategoryId(categoryId).setNationalityId(nationalityId).setCityId(cityId).setAreaId(areaId);

    return () => {
      advertListData.truncate();
    };
  }, [categoryId, nationalityId, cityId, areaId, advertListData]);

  if (isLoading) {
    return <ContentLoader />;
  }

  if (isError) {
    return null;
  }

  const advertListContextValue: AdvertListContextType = {
    storyDataList: data.storyDataList,
    filterData: data.filterData,
    advertDataListByDate,
    advertDataListByService,
    seo: data.seo,
    categoryId,
    nationalityId,
    cityId,
    areaId,
    isFetching,
  };

  return (
    <AdvertListContext value={advertListContextValue}>
      <AdvertListMetaData />
      <Page
        dataAttributeList={{
          categoryId,
          nationalityId,
          cityId,
          areaId,
        }}
      >
        <StoryList storyDataList={data.storyDataList} />
        <PageTitle title={data.seo.h1} />
        <Filter />
        <CatalogByDate />
        <CatalogByService />
        <SeoBlock text={data.seo.text} linkList={data.seo.linkList} cityList={data.seo.cityList} />
      </Page>
    </AdvertListContext>
  );
};

export default List;
